const isLocalDev = window.location.hostname === 'localhost'
  || window.location.hostname === '127.0.0.1'
  || window.location.protocol === 'file:';

const isRemoteDev = window.location.hostname.startsWith('192');

// Порт бэкенда в разработке. Обычно 3001; второй стенд (например, сервер с
// промо-матчем ИИ рядом с основным) поднимается с REACT_APP_DEV_API_PORT
const DEV_API_PORT = process.env.REACT_APP_DEV_API_PORT || '3001';

export const API_BASE = isLocalDev || isRemoteDev
  ? `http://${window.location.hostname}:${DEV_API_PORT}/api`
  : '/api';

export const WS_BASE = isLocalDev || isRemoteDev
  ? `ws://${window.location.hostname}:${DEV_API_PORT}/ws`
  : `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws`;
